import React from 'react'
import useMediaQuery from '../../../utils/useMediaQuery'
import ModalPreGameCard from './modalPreGameCard'

import zonaV from '../../../assets/images/games/personajes/zona-v.png'
import AppSlider from '../../atoms/appSlider/appSlider'
import Button from '../../atoms/button/button'
import pushPreGameMetric from './pushMetric'
import { 
  ReplicaImage1MBLinea3, 
  ReplicaImage2MBLinea3, 
  ReplicaImagePCLinea3, 
  textCountry } from './replica-pregame'

import { LOCALE } from '../../../constants/activity-constants'
const arg = LOCALE === "es-AR"

const Title = ({ mobile = false }) => {
  return (
    <div>
      <h2 className="f-modal-pre-game__card__title">
        ¡Bienvenida al{mobile ? <br /> : null} Planeta Zona V!
      </h2>
      {mobile ? (
        <>
          <br />
          <p className="--subtitle --center">¡Es momento de retarte!</p>{' '}
        </>
      ) : null}
    </div>
  )
}
const MobileVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    pushPreGameMetric('linea3', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <AppSlider settings={{ infinite: false }}>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__mobile-wrapper">
          <Title mobile={true} />
          <br /> <br />
          <figure style={{ height: 201 }}>
            <ReplicaImage1MBLinea3/>
          </figure>
          <br /> <br />
          <p className="--center --small">
            {textCountry.text13} las figuras, {textCountry.text14} posiciones y cuando {textCountry.text15} 
            3 o más figuras iguales, ¡desaparecerán!
          </p>
        </div>
      </ModalPreGameCard>
      <ModalPreGameCard onCancel={onEnd}>
        <div className="f-modal-pre-game__mobile-wrapper">
          <Title mobile={true} />
          <br /> <br />
          <figure>
            <ReplicaImage2MBLinea3/>
          </figure>
          <br />
          <br />
          <p className="--center --small">
            {textCountry.text6} estar muy pendiente, porque cada vez que salga un personaje de
            Nosotras, este va a ser un Bonus Track, así que {textCountry.text16} planear muy
            bien tus movimientos para que dupliques tus puntos.
          </p>
          <br />
          <br />
          <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
            ¡Quiero jugar ya!
          </Button>
        </div>
      </ModalPreGameCard>
    </AppSlider>
  )
}
const PcVersion = ({ onEnd }) => {
  const handlerCallToAction = e => {
    pushPreGameMetric('linea3', 'click', e.target.innerText)
    onEnd()
  }
  return (
    <ModalPreGameCard onCancel={onEnd}>
      <div>
        <Title />
        <br /> <br />
        <div className="f-modal-pre-game__flex-wrapper">
          <figure>
            <ReplicaImagePCLinea3/>
          </figure>
          <aside>
            <div className="f-modal-pre-game__flex-wrapper">
              <figure>
                <img src={zonaV} />
              </figure>
              <aside>
                <p>
                  <b>¡Sé la primera en el Top!</b>
                </p>
                <br /> <br />
                <p>
                  {textCountry.text13} las figuras, {textCountry.text14} posiciones y cuando {textCountry.text15}  
                   3 o más figuras iguales, ¡desaparecerán!
                </p>
              </aside>
            </div>
            <br />
            <p>
              <b>{textCountry.text6} estar muy pendiente,</b> porque cada vez que salga un
              personaje de Nosotras, este va a ser un Bonus Track, así que {textCountry.text19}
              planear muy bien tus movimientos para que dupliques tus puntos.
            </p>
            <br />
            {!arg &&
              <p>
                <b>Los Personaje Nosotras:</b> duplican tus puntos. “V”: triplica
                tus puntos.
              </p>
            }
            <br />
            <div>
              <Button onClick={handlerCallToAction} title="¡Quiero jugar ya!">
                ¡Quiero jugar ya!
              </Button>
            </div>
          </aside>
        </div>
      </div>
    </ModalPreGameCard>
  )
}
const PreGameLinea3 = ({ onEnd }) => {
  const isMobile = useMediaQuery()
  return isMobile ? (
    <MobileVersion onEnd={onEnd} />
  ) : (
    <PcVersion onEnd={onEnd} />
  )
}

export default PreGameLinea3
